import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/function';
import { getEq as SgetEq } from 'fp-ts/ReadonlySet';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const eqSetInterpreter = memo(() => ({
    _F: EqURI,
    set: (getEq, _ord, config) => env => pipe(getEq(env).eq, eq => new EqType(eqApplyConfig(config)(SgetEq(eq), env, { eq })))
}));
